export const SLIDEOVER_TITLE = {
  VEHICLE: {
    CREATE: "Create vehicle",
    UPDATE: "Update vehicle",
  },
  INSURANCE: {
    CREATE: "Create insurance",
    UPDATE: "Update insurance",
  },
  PROPERTY_DAMAGE: {
    CREATE: "Create property damage",
    UPDATE: "Update property damage",
  },
  INCIDENT_REPORT: {
    CREATE: "Create incident report",
    UPDATE: "Update incident report",
  },
  MATTER_TASK: {
    CREATE: "Create task",
    UPDATE: "Update task",
  },
  MATTER_CONTACT_CONNECTION: {
    CREATE: "Create contact connection",
    UPDATE: "Update contact connection",
  },
  MATTER_LITIGATION_DATE: {
    CREATE: "Create litigation date",
    UPDATE: "Update litigation date",
  },
  MATTER_LITIGATION_DATE_PLAN_CONNECTION: {
    CREATE: "Apply litigation date plan",
    UPDATE: "Apply litigation date plan",
  },
  LIEN: {
    CREATE: "Create lien",
    UPDATE: "Update lien",
  },
  LOST_WAGE: {
    CREATE: "Add employment",
    UPDATE: "Update lost wage",
  },
  NOTE: {
    CREATE: "Create note",
    UPDATE: "Update note",
  },
  SETTLEMENT_DEMAND: {
    CREATE: "Create settlement demand",
    UPDATE: "Update settlement demand",
  },
  SETTLEMENT_OFFER: {
    CREATE: "Create settlement offer",
    UPDATE: "Update settlement offer",
  },
  SETTLEMENT_COUNTER: {
    CREATE: "Create settlement counter",
    UPDATE: "Update settlement counter",
  },
  EXPENSE: {
    CREATE: "Create cost",
    UPDATE: "Update cost",
  },
  MEDICAL_TREATMENT: {
    CREATE: "Create medical treatment",
    UPDATE: "Update medical treatment",
  },
  TREATMENT_APPOINTMENT: {
    CREATE: "Create treatment date",
    UPDATE: "Update treatment date",
  },
  TREATMENT_BILL: {
    CREATE: "Create treatment bill",
    UPDATE: "Update treatment bill",
  },
  TREATMENT_BALANCE_CONFIRMATION: {
    CREATE: "Create balance confirmation",
    UPDATE: "Update balance confirmation",
  },
  TREATMENT_BALANCE_CONFIRMATION_HISTORY: {
    VIEW: "Balance confirmation history",
  },
  TREATMENT_RECORD: {
    CREATE: "Create treatment record",
    UPDATE: "Update treatment record",
  },
  TREATMENT_APPOINTMENT_ASSOCIATION: {
    CREATE: "Associate appointment records",
    UPDATE: "Associate appointment records",
  },
  TRUST_CHECK_DEPOSIT: {
    CREATE: "Create trust check deposit",
    UPDATE: "Update trust check deposit",
  },
  TRUST_CHECK_WITHDRAW: {
    CREATE: "Create trust check withdrawal",
    UPDATE: "Update trust check withdrawal",
  },
  FILE: {
    CREATE: "Create file",
    UPDATE: "Update file",
  },
  FOLDER: {
    CREATE: "Create folder",
    UPDATE: "Update folder",
  },
  SHARE_FOLDER: {
    CREATE: "Create share folder",
    UPDATE: "Update share folder",
  },
};

export const SLIDEOVER_DESCRIPTION = {
  VEHICLE: {
    CREATE: "Create a new vehicle",
    UPDATE: "Update the vehicle below",
  },
  INSURANCE: {
    CREATE: "Create a new insurance",
    UPDATE: "Update the insurance below",
  },
  PROPERTY_DAMAGE: {
    CREATE: "Create a new property damage",
    UPDATE: "Update the property damage below",
  },
  INCIDENT_REPORT: {
    CREATE: "Upload a new incident report",
    UPDATE: "Update the incident report below",
  },
  MATTER_TASK: {
    CREATE: "Create a new task",
    UPDATE: "Update the task below",
  },
  MATTER_CONTACT_CONNECTION: {
    CREATE: "Create a new contact connection",
    UPDATE: "Update the contact connection below",
  },
  MATTER_LITIGATION_DATE: {
    CREATE: "Create a new litigation date",
    UPDATE: "Update the litigation date below",
  },
  MATTER_LITIGATION_DATE_PLAN_CONNECTION: {
    CREATE: "Select a plan and add starting trigger dates",
    UPDATE: "Select a plan and add starting trigger dates",
  },
  LIEN: {
    CREATE: "Create a new lien",
    UPDATE: "Update the lien below",
  },
  LOST_WAGE: {
    CREATE: "Enter employment details below",
    UPDATE: "Update the lost wage below",
  },
  NOTE: {
    CREATE: "Create a new note",
    UPDATE: "Update the note below",
  },
  SETTLEMENT_DEMAND: {
    CREATE: "Create a new settlement demand",
    UPDATE: "Update the settlement demand below",
  },
  SETTLEMENT_OFFER: {
    CREATE: "Create a new settlement offer",
    UPDATE: "Update the settlement offer below",
  },
  SETTLEMENT_COUNTER: {
    CREATE: "Create a new settlement counter",
    UPDATE: "Update the settlement counter below",
  },
  EXPENSE: {
    CREATE: "Create a new cost",
    UPDATE: "Update the cost below",
  },
  MEDICAL_TREATMENT: {
    CREATE: "Create a new medical treatment",
    UPDATE: "Update the medical treatment below",
  },
  TREATMENT_APPOINTMENT: {
    CREATE: "Create a new treatment date",
    UPDATE: "Update the treatment date below",
  },
  TREATMENT_BILL: {
    CREATE: "Create a new treatment bill",
    UPDATE: "Update the treatment bill below",
  },
  TREATMENT_BALANCE_CONFIRMATION: {
    CREATE: "Create a new balance confirmation",
    UPDATE: "Update the balance confirmation below",
  },
  TREATMENT_BALANCE_CONFIRMATION_HISTORY: {
    VIEW: "View all balance confirmations for this treatment",
  },
  TREATMENT_RECORD: {
    CREATE: "Create a new treatment record",
    UPDATE: "Update the treatment record below",
  },
  TREATMENT_APPOINTMENT_ASSOCIATION: {
    CREATE: "Associate medical and billing records with appointments",
    UPDATE: "Associate medical and billing records with appointments",
  },
  TRUST_CHECK_DEPOSIT: {
    CREATE: "Create a new trust check deposit",
    UPDATE: "Update the trust check deposit below",
  },
  TRUST_CHECK_WITHDRAW: {
    CREATE: "Create a new trust check withdrawal",
    UPDATE: "Update the trust check withdrawal below",
  },
  FILE: {
    CREATE: "Create a new file",
    UPDATE: "Update the file below",
  },
  FOLDER: {
    CREATE: "Create a new folder",
    UPDATE: "Update the folder below",
  },
  SHARE_FOLDER: {
    CREATE: "Create a new shared folder to share externally",
    UPDATE: "Update the shared folder details",
  },
};

export const SLIDEOVER_CONFIRM_CLOSE_DESCRIPTION =
  "You have unsaved changes. Leaving this form will discard your changes. Are you sure you want to continue?";
